export default __webpack_public_path__ + "static/media/no-events-found.7d61df59.png";